
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.067 5.208c-.946-.884-.914-1.812-1.172-3.828A.444.444 0 0014.45 1h-1.405a.44.44 0 00-.446.435c0 4.198-1.165 3.542-3.575 8.232-2.41-4.69-3.576-4.034-3.576-8.232A.44.44 0 005.003 1H3.598a.444.444 0 00-.443.38c-.257 1.978-.22 2.934-1.173 3.828-2.871 2.68 1.514 4.485 1.055 7.04l-1.163 8.284A.438.438 0 002.32 21h13.41a.441.441 0 00.445-.468l-1.49-8.283c-.46-2.554 4.253-4.36 1.382-7.041z","stroke":"currentColor","stroke-width":"1.333","fill":"none","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    